export const payments = {
    namespaced: true,
    state: {
        userPeriodPrices: []
    },
    mutations: {
        SET_USER_PERIOD_PRICES(state, payload) {
            state.userPeriodPrices = payload
        }

    },
    actions: {
        async fetchUserPeriodPrices({ commit }) {
            const response = await this.$api.get('api/user-period-prices')
            commit('SET_USER_PERIOD_PRICES', response.data.data)
        },
        async repeatPayment(context, payload) {
            const response = await this.$api.get(`api/payments/repeat/${payload}`)
            return response
        }
    },
    getters: {
        getUserPeriodPrices: (state) => {
            return state.userPeriodPrices
        }

    }
}
